import * as constants from "@/constants";
import environments from "@/environments";
import { stripHashFromHexColor } from "@/sx-layout/utils";

export const fetchLayoutMasters = () => {
  const endpoint = `${environments.API_BASE_URI}/construction/layout_masters`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "GET",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    callbacks: {
      begin: () => {
        return {
          type: constants.LAYOUT_MASTERS_BEGIN_FETCH_MASTERS,
        };
      },
      success: (response) => {
        return {
          type: constants.LAYOUT_MASTERS_END_FETCH_MASTERS,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const updateLayoutMachineIconSetting = (
  props: {
    machine_icon_id: number;
    icon_color: string;
  }[],
  callback?: (res) => void
) => {
  const endpoint = `${environments.API_BASE_URI}/constructions_machine_icons/update`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify({
      constructions_machine_icons: props.map((prop) => ({
        machine_icon_id: prop.machine_icon_id,
        icon_color: stripHashFromHexColor(prop.icon_color),
      })),
    }),
    callbacks: {
      begin: () => {
        return {
          type: constants.LAYOUT_BEGIN_UPDATE_ICON_SETTINGS,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.LAYOUT_END_UPDATE_ICON_SETTINGS,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
